module.exports = "<p>\n  payment works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/payment/payment.component.html
// module id = ./src/app/payment/payment.component.html
// module chunks = main